import { render, staticRenderFns } from "./pageListz.vue?vue&type=template&id=ffe2a808&scoped=true&"
import script from "./pageListz.vue?vue&type=script&lang=js&"
export * from "./pageListz.vue?vue&type=script&lang=js&"
import style0 from "./pageListz.vue?vue&type=style&index=0&id=ffe2a808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe2a808",
  null
  
)

export default component.exports